import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import SideBar from "../SideBar/SideBar";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    width: "100%",
    marginTop: "1%",
    height: "calc(100% - 155px)",
    overflowY: "auto",
  },
content: {
  width: "calc(100% - 260px)",

  "& .inputFieldContainer": {
    maxWidth: "1050px",
    margin: "0 auto",
  },

  "& .fieldContaienr": {
    margin: "2% 2% 0px 2%",
    maxWidth: "28%",
  },

  "& $header": {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
  },

  [theme.breakpoints.down("md")]: {
    width: "100%",

    "& .fieldContaienr": {
      maxWidth: "45%",
      margin: "2%",
    },
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%",

    "& .fieldContaienr": {
      maxWidth: "100%",
      margin: "10px 0",
    },
  },
},

}));

const InnerContent = ({ handleDrawerToggle, mobileOpen }) => {
  const classes = useStyles();
  const [sidebarLinks, setSidebarLinks] = useState([]); // dynamic links

  return (
    <div className={classes.container}>
      <SideBar handleDrawerToggle={handleDrawerToggle} open={mobileOpen} links={sidebarLinks} />
      <div className={classes.content}>
        <Outlet context={{ sidebarLinks, setSidebarLinks }} />
      </div>
    </div>
  );
};

InnerContent.propTypes = {
  handleDrawerToggle: PropTypes.func,
  mobileOpen: PropTypes.bool,
};

export default InnerContent;
